<template>
<div class="home-open-view">
    <moo-popover :close-delay="0" popper-class="cloud-open-popper" placement="top" trigger="hover" :content="$t('在浏览器中打开#!!!#src/pages/H5/Cloud/components/popper/openPopper.vue_1')">
      <div @click="openPopper" slot="reference" class="cloud-top">
        <!-- <svg-icon
          slot="reference"
          iconClass="cloud-home-open"
          class="header-icon cloud-home-open"
        ></svg-icon> -->
        <CloudPreviewIconBroswer></CloudPreviewIconBroswer>
      </div>
    </moo-popover>
    <!-- <div class="line"></div> -->
  </div>
</template>

<script>
import CloudPreviewIconBroswer from "./cloud-preview-icon-broswer.vue";

export default {
  name: "OpenPopper",
  components: {
    CloudPreviewIconBroswer,
  },
  props: {
    isHome: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    openPopper() {
      console.log("openPopper");
      // if(this.isHome) {
      //     window.parent.postMessage("home-new-tab", "*");
      //     return
      // }
      window.open(window.location.href, "_blank");
    },
  },
};
</script>

<style lang="scss">
.home-open-view {
  margin-left: 12px;
  width: 26px;
  height: 26px;
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f4f6f9;
    border-radius: 4px;
  }

  &:focus-visible {
    outline: none;
  }

  .cloud-top {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      &:focus {
        outline: none;
      }
    }
  }

  .line {
    width: 1px;
    height: 16px;
    background: #e2e6ed;
    border-radius: 1px;
    margin: 0 16px;
  }
}

.cloud-open-popper {
  width: 114px !important;
  min-width: 114px !important;
  padding: 0 !important;
  /* margin: 0 !important; */
  margin-bottom: 5px !important;
  line-height: 36px !important;
  text-align: center !important;
  height: 36px !important;
  background: #ffffff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  font-weight: 400;
  font-size: 14px;
  color: #767c85;
  box-sizing: border-box;

  .popper__arrow {
    display: none !important;
  }
}

.cloud-home-open {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  width: 16px;
  height: 16px;

  &:hover {
    background: #f4f6f9;
    border-radius: 4px;
  }
}
</style>
